<p-sidebar
    styleClass="w-498"
    (onHide)="onHide()"
    [visible]="isVisible"
    position="right"
>
    <ng-content></ng-content>
</p-sidebar>
